import { api } from './apiClient';

/** Bloco 37: backup automático por e-mail (Configurações → Backup Automático). */
export type BackupFormat = 'PDF' | 'CSV';
export type BackupFrequency = 'DIARIA' | 'SEMANAL' | 'QUINZENAL' | 'MENSAL';

export type BackupSettings = {
  enabled: boolean;
  format: BackupFormat;
  frequency: BackupFrequency;
  lastSentAt: string | null;
  email: string;
  role: string;
  /** false quando o servidor não tem SMTP configurado (nada é entregue). */
  deliveryConfigured: boolean;
};

export const BACKUP_FREQUENCY_LABELS: Record<BackupFrequency, string> = {
  DIARIA: 'Diária',
  SEMANAL: 'Semanal',
  QUINZENAL: 'Quinzenal',
  MENSAL: 'Mensal',
};

export function fetchBackupSettings(): Promise<BackupSettings> {
  return api.get<BackupSettings>('/backup/settings');
}

export function updateBackupSettings(payload: Partial<Pick<BackupSettings, 'enabled' | 'format' | 'frequency'>>): Promise<BackupSettings> {
  return api.patch<BackupSettings>('/backup/settings', payload);
}

export function sendBackupNow(): Promise<{ sent: boolean; to: string; filename: string; bytes: number }> {
  return api.post('/backup/send-now', {});
}
